import {
  SUPPORT_SEARCH_CUSTOMER_RESET_STATUS,
  SUPPORT_SEARCH_CUSTOMER_START,
  SUPPORT_SEARCH_CUSTOMER_SUCCESS,
  SUPPORT_SEARCH_CUSTOMER_FAIL,
  CREATE_APPLICATION_START,
  CREATE_APPLICATION_SUCCESS,
  CREATE_APPLICATION_FAIL,
  GET_SUBSCRIBER_START,
  GET_SUBSCRIBER_SUCCESS,
  GET_SUBSCRIBER_FAIL,
  GET_APPLICATIONS_START,
  GET_APPLICATIONS_SUCCESS,
  GET_APPLICATIONS_FAIL,
  GET_DETAILED_APPLICATION_START,
  GET_DETAILED_APPLICATION_SUCCESS,
  GET_DETAILED_APPLICATION_FAIL,
  PATCH_HANDLER_APPLICATION_START,
  PATCH_HANDLER_APPLICATION_SUCCESS,
  PATCH_HANDLER_APPLICATION_FAIL,
  GET_BALANCE_START,
  GET_BALANCE_SUCCESS,
  GET_BALANCE_FAIL,
  GET_TRANSACTIONS_START,
  GET_TRANSACTIONS_SUCCESS,
  GET_TRANSACTIONS_FAIL,
  GET_BONUSES_SUCCESS,
  GET_BONUSES_FAIL,
  GET_BONUSES_START
} from './constants';
import {
  getSearchCustomerSupport,
  requestCreateApplication,
  requestSubscriberSupport,
  requestGetApplications,
  requestGetDetailedApplication,
  requestPatchHandlerApplication,
  requestGetBalance,
  requestGetTransactions,
  requestGetBonuses,
  requestGetApplicationsByManagerId,
} from '../../api/support';
import { action } from '../action';

export const supportSearchCustomerResetStatus = () => ({
  type: SUPPORT_SEARCH_CUSTOMER_RESET_STATUS
});

export const actionSearchCustomer = action(
  SUPPORT_SEARCH_CUSTOMER_START,
  SUPPORT_SEARCH_CUSTOMER_SUCCESS,
  SUPPORT_SEARCH_CUSTOMER_FAIL
);
export const getSearchCustomer =
  (
    payload
    // redirectToUserCard
  ) =>
  async (dispatch) => {
    try {
      dispatch(actionSearchCustomer.start());
      const data = await getSearchCustomerSupport(payload.params);
      // .then((res) => {
      //   dispatch(actionSearchCustomer.success(res));
      //   redirectToUserCard(payload, res?.personal_accounts[0].id);
      // });
      dispatch(actionSearchCustomer.success(data.data));
      return data;
    } catch (error) {
      dispatch(actionSearchCustomer.fail(error.detail));
      return error.response;
    }
  };

export const actionCreateApplication = action(
  CREATE_APPLICATION_START,
  CREATE_APPLICATION_SUCCESS,
  CREATE_APPLICATION_FAIL
);
export const postCreateApplication = (payload, redirectToApplications) => async (dispatch) => {
  try {
    dispatch(actionCreateApplication.start());
    const data = await requestCreateApplication(payload);
    dispatch(actionCreateApplication.success(data));
    redirectToApplications && redirectToApplications();
  } catch (error) {
    dispatch(actionCreateApplication.fail(error.detail));
  }
};

export const actionSubscriber = action(
  GET_SUBSCRIBER_START,
  GET_SUBSCRIBER_SUCCESS,
  GET_SUBSCRIBER_FAIL
);
export const getSubscriber = (id) => async (dispatch) => {
  try {
    dispatch(actionSubscriber.start());
    const data = await requestSubscriberSupport(id);
    dispatch(actionSubscriber.success(data));
  } catch (error) {
    dispatch(actionSubscriber.fail(error.detail));
  }
};

export const actionApplications = action(
  GET_APPLICATIONS_START,
  GET_APPLICATIONS_SUCCESS,
  GET_APPLICATIONS_FAIL
);
export const getApplications = (filter) => async (dispatch) => {
  try {
    dispatch(actionApplications.start());
    const data = await requestGetApplications(filter);

    dispatch(actionApplications.success(data));
  } catch (error) {
    dispatch(actionApplications.fail(error.detail));
  }
};
export const getApplicationsByManagerId = (filter, managerId) => async (dispatch) => {
  try {
    dispatch(actionApplications.start());
    const data = await requestGetApplicationsByManagerId(filter, managerId);

    dispatch(actionApplications.success(data));
  } catch (error) {
    dispatch(actionApplications.fail(error.detail));
  }
};

export const actionDetailedApplication = action(
  GET_DETAILED_APPLICATION_START,
  GET_DETAILED_APPLICATION_SUCCESS,
  GET_DETAILED_APPLICATION_FAIL
);
export const getDetailedApplication = (id) => async (dispatch) => {
  try {
    dispatch(actionDetailedApplication.start());
    const data = await requestGetDetailedApplication(id);

    dispatch(actionDetailedApplication.success(data));
  } catch (error) {
    dispatch(actionDetailedApplication.fail(error.detail));
  }
};

export const actionHandlerApplication = action(
  PATCH_HANDLER_APPLICATION_START,
  PATCH_HANDLER_APPLICATION_SUCCESS,
  PATCH_HANDLER_APPLICATION_FAIL
);
export const postHandlerApplication = (id, payload) => async (dispatch) => {
  try {
    dispatch(actionHandlerApplication.start());
    const data = await requestPatchHandlerApplication(id, payload);

    dispatch(actionHandlerApplication.success(data));
  } catch (error) {
    dispatch(actionHandlerApplication.fail(error.detail));
  }
};

export const actionGetBalance = action(GET_BALANCE_START, GET_BALANCE_SUCCESS, GET_BALANCE_FAIL);
export const GetBalance = (iin) => async (dispatch) => {
  try {
    dispatch(actionGetBalance.start());
    const data = await requestGetBalance(iin);

    dispatch(actionGetBalance.success(data));
  } catch (error) {
    dispatch(actionGetBalance.fail(error.detail));
  }
};

export const actionTransactions = action(
  GET_TRANSACTIONS_START,
  GET_TRANSACTIONS_SUCCESS,
  GET_TRANSACTIONS_FAIL
);
export const GetTransactions = (iin, payload) => async (dispatch) => {
  try {
    dispatch(actionTransactions.start());
    const data = await requestGetTransactions(iin, payload);
    dispatch(actionTransactions.success(data));
  } catch (error) {
    dispatch(actionTransactions.fail(error.detail));
  }
};

export const actionBonuses = action(
  GET_BONUSES_START,
  GET_BONUSES_SUCCESS,
  GET_BONUSES_FAIL
);
export const GetBonuses = (iin) => async (dispatch) => {
  try {
    dispatch(actionBonuses.start());
    const data = await requestGetBonuses(iin);
    dispatch(actionBonuses.success(data));
  } catch (error) {
    dispatch(actionBonuses.fail(error.detail));
  }
};
